import { Spinner, StatusBadge, StatusBadgeProps } from '@apollo/orbit';
import { capitalize } from 'lodash';
import React, { ReactElement, useMemo } from 'react';

import { GraphQLTypes } from 'src/lib/graphqlTypes';

export const RouterHealthBadge = ({
  routerStatus,
  isInitiating,
}: {
  routerStatus: GraphQLTypes.RouterStatus | undefined;
  isInitiating: boolean;
}) => {
  const {
    title,
    icon,
    colorScheme = 'gray',
  } = useMemo((): {
    title: GraphQLTypes.RouterStatus | 'LOADING' | 'ERROR';
    icon?: ReactElement;
    colorScheme?: StatusBadgeProps['colorScheme'];
  } => {
    const loadingContent = {
      title: routerStatus ?? ('LOADING' as const),
      icon: <Spinner size="tiny" />,
    };
    switch (routerStatus) {
      case GraphQLTypes.RouterStatus.RUNNING:
        return {
          title: routerStatus,
          colorScheme: 'green',
        };
      case GraphQLTypes.RouterStatus.CREATING:
      case GraphQLTypes.RouterStatus.DELETING:
      case GraphQLTypes.RouterStatus.ROLLING_BACK:
      case GraphQLTypes.RouterStatus.UPDATING:
        return loadingContent;
      case undefined:
        return isInitiating
          ? loadingContent
          : {
              title: 'ERROR',
              colorScheme: 'red',
            };
      case GraphQLTypes.RouterStatus.DELETED:
        return {
          title: routerStatus,
          colorScheme: 'red',
        };
      default:
        return {
          title: 'ERROR',
          colorScheme: 'red',
        };
    }
  }, [isInitiating, routerStatus]);

  return (
    <StatusBadge colorScheme={colorScheme} icon={icon}>
      {capitalize(title.toLowerCase())}
    </StatusBadge>
  );
};
